export class FeaturedProductListContentSwap {
    constructor (element) {
        if (!element) return;

        this.element = element;
        this.contexts = [...this.element.querySelectorAll('.js-featured-product-list-content-swap-context')];
        this.contents = [...this.element.querySelectorAll('.js-featured-product-list-content-swap-content')];
        this.desktopBreakpoint = 1280;
        this.init();
    }

    init () {
        const largeMq = window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`);
        largeMq.addEventListener('change', event => {
            if (event.matches) {
                this.destroyMobileTriggers();
                this.initDesktopTriggers();
                this.contents.forEach(element => element.inert = false);
            } else {
                this.destroyDesktopTriggers();
                this.initMobileTriggers();
                this.contents.slice(1).forEach(element => element.inert = true);
            }
        });

        window.addEventListener('DOMContentLoaded', () => {
            if (window.innerWidth >= this.desktopBreakpoint) {
                this.contents.forEach(element => element.inert = false);
                this.initDesktopTriggers();
            } else {
                this.contents.slice(1).forEach(element => element.inert = true);
                this.initMobileTriggers();
            }
        });
    }

    initMobileTriggers () {
        document.addEventListener('click', this.mobileTriggerClickCallback.bind(this));
    }

    mobileTriggerClickCallback (event) {
        if (event.target.closest('.js-featured-product-list-content-swap-mobile-trigger')) {
            const trigger = event.target;

            this.contents.forEach(element => element.inert = true);
            [...this.element.querySelectorAll('.js-featured-product-list-content-swap-mobile-trigger')].forEach(trigger => trigger
                .closest('.js-featured-product-list-content-swap-context')
                .classList
                .remove('is-active')
            );
            
            trigger.closest('.js-featured-product-list-content-swap-context')
                .classList
                .add('is-active');

            trigger.closest('.js-featured-product-list-content-swap-context')
                .querySelector('.js-featured-product-list-content-swap-content')
                .inert = false;
        }
    }

    destroyMobileTriggers () {
        document.removeEventListener('click', this.mobileTriggerClickCallback);
        this.contexts.forEach(context => {
            context.classList.remove('is-active');
        });

        this.contexts[0].classList.add('is-active');
    }

    initDesktopTriggers () {
        this.element.addEventListener('mouseover', this.desktopTriggerMouseoverCallback);
        this.element.addEventListener('mouseout', this.desktopTriggerMouseoutCallback);
    }

    desktopTriggerMouseoverCallback (event) {
        if (event.target.closest('.js-featured-product-list-content-swap-context')) {
            const target = event.target.closest('.js-featured-product-list-content-swap-context');

            document.querySelector('.js-featured-product-list-content-swap-context').classList.remove('is-active');
            target.classList.add('is-active');
        }
    }

    desktopTriggerMouseoutCallback (event) {
        if (event.target.closest('.js-featured-product-list-content-swap-context')) {
            const target = event.target.closest('.js-featured-product-list-content-swap-context');

            target.classList.remove('is-active');
            document.querySelector('.js-featured-product-list-content-swap-context').classList.add('is-active');
        }
    }

    destroyDesktopTriggers () {
        this.element.removeEventListener('mouseover', this.desktopTriggerMouseoverCallback);
        this.element.removeEventListener('mouseout', this.desktopTriggerMouseoutCallback);
    }
}
